<template>
    <div>
        <div v-if="showData()">
            <ul role="list" class="grid grid-cols-1 gap-4 xs:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 " >
                <li v-for="row in dataRows" :key="row.id" 
                    :class="[
                        'card', 
                        searchSelected(row.id) ? 'card-selected' : ''
                    ]" 
                    @click="show($event, row)">
                    <UserCardLarge :row="row" :status="inative(row.status)" :selected="selected" />
                </li>
            </ul>
        </div>

        <div v-else>
            <Cell :p="false" :b="true">
                <noData type="user_cards" />
            </Cell>
        </div>
    </div>  
</template>


<script>

import UserCardLarge from './_partials/UserCardLarge.vue';



export default {
    name: "ListUsersCard",
    props: {
        dataRows: {
            type: Object,
            required: false
        },
        selected: {
            type: Array,
            required: false
        },
        show: {
            type: Function,
            required: false
        },
        cols: {
            type: Number,
            default: 3,
            required: false
        },
        colsForce: {
            type: Boolean,
            default: false,
            required: false
        },
        cardSize: {
            type: String,
            default: 'sm',
            required: false
        },

    },
    components: {
        UserCardLarge,
    },
    methods: {
        showData(){
            try{
                if(this.dataRows.length){
                    return true;
                }
                return false 
            } catch(e){
                return false;
            }            
        },

        rounded(){

            if(this.cardSize && this.cardSize == 'xs'){
                return 'rounded-full';
            }
            else {
                return 'rounded-lg';
            }

        },

        inative(status){
            if(status == 'inative'){
                return true;
            }
            return false;
        },
        processAttribute(key, attribute) {
            return Attributs.process(key, attribute); 
        },
        searchSelected(id) {        
            return this.selected.indexOf(id) > -1;
        },
    },    
}

</script>

<style scoped>
.card {
    @apply rounded-md cursor-pointer col-span-1 flex flex-col text-center bg-white divide-y divide-gray-200 border-2 border-white hover:border-amber-600 transition-all duration-300 ease-in-out;
}

.card:hover {
    transform: scale(1.05);
}

.card-selected {
    @apply border-amber-600;
}

.isSelected {
    @apply bg-amber-50 text-gray-800;
}
</style>